import React, {useState} from "react";
import axios from "axios";
import {baseUrl} from '../Univ.js'
export default function TamilMedicalTranscriber() {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const handleUpload = async () => {
        if (!file) return alert("Select audio file first");
        const formData = new FormData();
        formData.append("audio", file);
        setLoading(true);
        try {
            const res = await axios.post(
                `${baseUrl}transcribe/`,
                formData,
                {headers: {"Content-Type": "multipart/form-data"}}
            );
            setData(res.data);
        } catch (err) {
            console.error(err);
            alert("Transcription failed");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div style={{padding: 20}}>
            <h2>Doctor–Patient Tamil Conversation → English Transcript</h2>

            <input
                type="file"
                accept="audio/*"
                onChange={e => setFile(e.target.files[0])}
            />

            <button onClick={handleUpload} disabled={loading}>
                {loading ? "Processing..." : "Upload & Transcribe"}
            </button>

            {data && (
                <>
                    <h3>Detected Language: {data.detected_language}</h3>

                    <h3>Tamil Transcript</h3>
                    <pre>{data.native_transcript}</pre>

                    <h3>English Translation</h3>
                    <pre>{data.english_transcript}</pre>

                    <h4>Timestamp Segments</h4>
                    <ul>
                        {data.segments_json?.map((s, i) => (
                            <li key={i}>
                                [{s.start} → {s.end}] {s.text}
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
}
